import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/auth.service';
import { GoogleService } from '../../shared/google.service';

@Component({
  selector: 'app-login',
  styleUrls: ['login.component.scss'],
  templateUrl: 'login.component.html',
})
export class LoginComponent {
  loginForm: UntypedFormGroup;
  message: string;
  messageGoogle: string;

  constructor(
    private fb: UntypedFormBuilder,
    public authService: AuthService,
    public googleService: GoogleService,
    public router: Router,
  ) {}

  ngOnInit() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.email, Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  async submit() {
    this.message = '';

    const response = await this.authService.login(this.loginForm.value);

    if (response === true) {
      this.router.navigateByUrl('/');
    } else {
      if (response.status === 403 || response.status === 400) {
        this.message = 'Invalid credentials, try again.';
      } else {
        this.message = 'Server error, try again later.';
      }
    }
  }

  getValidationClass(field: string) {
    const control = this.loginForm.controls[field];
    return {
      'is-valid': control.valid && (control.dirty || control.touched),
      'is-invalid': control.invalid && (control.dirty || control.touched),
    };
  }

  async loginWithGoogle() {
    this.messageGoogle = '';
    const response = await this.googleService.authenticate();
    console.log({ response }, 111);
    if (response === true) {
      this.router.navigateByUrl('/');
    } else {
      if (response.status === 403 || response.status === 400) {
        this.messageGoogle = 'This Google account is not linked to LossControl Plus';
      } else {
        this.messageGoogle = 'Server error, try again later.';
      }
    }
  }
}
